<template>
  <div
    :style="styles"
    class="select-none overflow-hidden rounded-2xl border border-zinc-200/70 bg-white shadow-xl dark:border-zinc-800 dark:bg-zinc-900/95 dark:shadow-2xl dark:shadow-black/30"
    :class="{ 'max-w-sm lg:max-w-lg': width === 'auto' }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      default: 120,
    },
  },

  computed: {
    styles() {
      return {
        width: this.width === 'auto' ? 'auto' : `${this.width}px`,
      }
    },
  },
}
</script>
